var render, staticRenderFns
import script from "./data_synchronism.vue?vue&type=script&lang=js&"
export * from "./data_synchronism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14286c02')) {
      api.createRecord('14286c02', component.options)
    } else {
      api.reload('14286c02', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/execute/terminal_record_flow/form/data_synchronism.vue"
export default component.exports